export const ibanToAccountNumber = (iban: string): string => {
  if (!iban || iban.length < 5) return '';
  const accountNumber = iban.substr(14, 10).replace(/^0+/, '');
  const prefix = iban.substr(8, 6).replace(/^0+/, '');
  const bankCode = iban.substr(4, 4);
  return `${prefix}${
    (prefix.length > 0 && '-') || ''
  }${accountNumber}/${bankCode}`;
};
